import { Events } from '@/utils/servicesEvents'
import { Network } from '@/utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getStoresBalances(stores, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(stores)
  const parsedResponse = parseResponse(response, stores)
  const event = parsedResponse.statusCode == 200 ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(event, parsedResponse)
}

async function sendRequest(stores) {
  const url = urls.proxyRequestSimultaneous
  const data = {
    requests: [],
  }
  stores.forEach(store => {
    data.requests.push({
      method: 'get',
      id: 'availableBalance_' + store.id,
      url: `${urls.getBalance}${store.id}`,
    })
    data.requests.push({
      method: 'get',
      id: 'pendingBalance_' + store.id,
      url: `${urls.getBalancePending}${store.id}`,
    })
  })
  const response = await Network.sendPostRequest(url, data)

  return response
}

function parseResponse(response, stores) {
  if (response && response.status.code === 200) {
    const rawData = response.response
    const appData = Formatter.parseStoresBalances(rawData, stores)

    return {
      statusCode: 200,
      data: appData,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getStoresBalances }
